import {
  CreateTaskPage,
  EditTaskPage,
  HomePage,
  LoginPage,
  TasksPage,
  AboutPage,
  AdminPage,
  RecurringTasksPage,
  FeedbackPage,
  CompletedTasksPage,
  GeneralFeedbackPage,
  ReportABugPage,
  RequestAFeaturePage,
  ActivitiesPage,
  AccountPage,
  SubscribePage,
  PlannerPage,
  DeleteAccountPage,
  DashboardPage,
} from "../pages";

import { getAboutRoutes } from "./about-routes";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";

const routes = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "tasks",
    element: <TasksPage />,
  },
  {
    path: "create-task",
    element: <CreateTaskPage />,
  },
  {
    path: "edit-task",
    element: <EditTaskPage />,
  },
  {
    path: "about",
    element: <AboutPage />,
  },
  {
    path: "admin",
    element: <AdminPage />,
  },
  {
    path: "feedback",
    element: <FeedbackPage />,
  },
  {
    path: "feedback/report-a-bug",
    element: <ReportABugPage />,
  },
  {
    path: "feedback/request-a-feature",
    element: <RequestAFeaturePage />,
  },
  {
    path: "feedback/general",
    element: <GeneralFeedbackPage />,
  },
  {
    path: "recurring-tasks",
    element: <RecurringTasksPage />,
  },
  {
    path: "activities",
    element: <ActivitiesPage />,
  },
  {
    path: "account",
    element: <AccountPage />,
  },
  {
    path: "subscribe",
    element: <SubscribePage />,
  },
  {
    path: "privacy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "delete-account",
    element: <DeleteAccountPage />,
  },
  {
    path: "planner",
    element: <PlannerPage />,
  },
  {
    path: "completed-tasks",
    element: <CompletedTasksPage />,
  },
  {
    path: "dashboard",
    element: <DashboardPage />,
  },
];

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
// ~~~~~ Please remember you may need to add new public routes to the AppLoader component in components/loading/AppLoader.js ~~~~~
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

export const getRoutes = () => {
  return [...routes, ...getAboutRoutes()];
};
